import React, { useState } from 'react';
import SelectBox from './SelectBox';

const PlanningPopup = ({ isOpen, onClose, onSubmit }) => {
    const [entries, setEntries] = useState([{ plan_date: '', sku: '', qty_boxes: '' }]);

    const handleAddEntry = () => {
        setEntries([...entries, { plan_date: '', sku: '', qty_boxes: '' }]);
    };

    const handleRemoveEntry = (index) => {
        const newEntries = entries.filter((_, i) => i !== index);
        setEntries(newEntries);
    };

    const handleChange = (index, field, value) => {
        const newEntries = [...entries];
        newEntries[index][field] = value;
        setEntries(newEntries);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(entries.filter(entry => entry.plan_date && entry.sku && entry.qty_boxes));
    };

    if (!isOpen) return null;

    return (
        <div className="popup-overlay">
            <div className="popup-content">
            <button className="close-btn" onClick={onClose}>
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <use xlinkHref="#closeBtn"></use>
                        </svg>
                    </button>
                <h2 className="popup-title">Add new record to shipments planning</h2>
               
                <form onSubmit={handleSubmit}>
                    {entries.map((entry, index) => (
                        <div key={index} className="entry-block">
                            <div className="form-group">
                                <label className="label">Date:</label>
                                <input
                                    type="date"
                                    className="form__input"
                                    value={entry.plan_date}
                                    onChange={(e) => handleChange(index, 'plan_date', e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label className="label">Set:</label>
                                <SelectBox
                                    tableName="sets"
                                    displayField="setmane"
                                    updateField="SKU"
                                    selectedValue={entry.sku}
                                    onChange={(value) => handleChange(index, 'sku', value)}
                                />
                            </div>
                            <div className="form-group">
                                <label className="label">Boxes QTY:</label>
                                <input
                                    type="number"
                                    className="form__input"
                                    value={entry.qty_boxes}
                                    onChange={(e) => handleChange(index, 'qty_boxes', e.target.value)}
                                    required
                                />
                            </div>
                            {entries.length > 1 && (
                                <button 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={() => handleRemoveEntry(index)}
                                >
                                    Delete SKU
                                </button>
                            )}
                        </div>
                    ))}
                    <button 
                        type="button" 
                        className="btn btn-secondary"
                        onClick={handleAddEntry}
                    >
                        Add more SKU
                    </button>
                    <button type="submit" className="btn btn-green">Submit</button>
                </form>
            </div>
        </div>
    );
};

export default PlanningPopup;
